<template>
  <component :is="currentComponent"></component>
</template>

<script>
import HormoneReplacementContentEn from './HormoneReplacementContent/HormoneReplacementContentEn.vue';
import HormoneReplacementContentPtBR from './HormoneReplacementContent/HormoneReplacementContentPtBR.vue';
import HormoneReplacementContentEs from './HormoneReplacementContent/HormoneReplacementContentEs.vue';
import { LANGUAGES } from '@/common/constants';

export default {
  props: {
    language: {
      type: String,
      default: LANGUAGES.EN
    }
  },
  computed: {
    currentComponent() {
      if (this.language === LANGUAGES.PT_BR) {
        return HormoneReplacementContentPtBR;
      }
      if (this.language === LANGUAGES.ES) {
        return HormoneReplacementContentEs;
      }
      return HormoneReplacementContentEn;
    }
  }
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
